import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import ChartContext from '../context/ChartContext';

const StyledChartItemQuantity = styled.div`
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: absolute;
  right: 12%;
  font-size: 20px;
  padding: 5px;
  margin-top: 5px;
`

const ChartItemQuantity = () => {
  const { chartTotal } = useContext(ChartContext);

  useEffect(() => {
    // console.log(chartQuantity);    
  }, [chartTotal]);

  return (
    <StyledChartItemQuantity>
      {chartTotal.itemsTotal}
    </StyledChartItemQuantity>
  )
}

export default ChartItemQuantity;